import OfficeBuildingIcon from '@atlaskit/icon/core/office-building';
import * as React from 'react';

export function SvgDomain() {
  return <OfficeBuildingIcon label="" testId="ads-refreshed-icon" />;
}
